/**
 * --------------------------------------------------------------------------
 * NJ : Tag.js
 * --------------------------------------------------------------------------
 */

import { Data, EventHandler, Manipulator } from 'nj-utils';
import AbstractComponent from './AbstractComponent';
import { coreConfig } from 'nj-components/core.config';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

// Required const for all components :
const DATA_KEY = `${coreConfig.KEY_PREFIX}.tag`;
const KEYFRAMES = [
  {
    opacity: 1
  },
  {
    opacity: 0
  }
];

const SELECTOR = '.nj-tag:not(.disabled)';

class Tag extends AbstractComponent {
  constructor(element, config) {
    super(Tag, element, Manipulator.extend(true, {}, config));

    EventHandler.on(element, 'click', this.handleClick.bind(this));

    if (this.element) {
      Data.setData(element, DATA_KEY, this);
    }
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  close(event) {
    const rootElement = Tag.getRootElement(event.target);

    rootElement.animate(KEYFRAMES, {
      duration: 200,
      delay: 70,
      easing: 'ease-out'
    }).onfinish = () => {
      Tag.destroyElement(rootElement);
    };
  }

  handleClick(event) {
    if (event.target.closest('.nj-tag__icon')) {
      this.close(event);
    }
  }

  static init(options) {
    return super.init(this, options, SELECTOR);
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  static getRootElement(element) {
    return element.closest(SELECTOR);
  }

  // Remove element from DOM
  static destroyElement(element) {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }

  // Static
  static selector = SELECTOR;
}

export default Tag;
